if (!customElements.get('wb-faq-sizing')) {
  customElements.define('wb-faq-sizing', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const targets = () => ({
        trigger: this.hasAttribute('data-product-guidance') ? null : document.querySelector('button.scr-open-size-chart'),
        panel: this.dataset.productChart === 'true' ? document.querySelector('wb-product-information details[data-info="size"]:not([hidden])') : null,
      });
      const sync = () => {
        const { trigger, panel } = targets();
        const available = Boolean(trigger || panel);
        this.querySelector('[data-faq-chart]').hidden = !available;
        this.querySelector('[data-faq-size-fallback]').hidden = available;
      };
      this.querySelector('button').addEventListener('click', () => {
        const { trigger, panel } = targets();
        if (panel) {
          panel.open = true;
          panel.style.scrollMarginTop = '90px';
          panel.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          panel.querySelector('summary')?.focus({ preventScroll: true });
        } else if (trigger) {
          trigger.click();
        }
      }, { signal: this.abort.signal });
      this.closest('details')?.addEventListener('toggle', sync, { signal: this.abort.signal });
      this.observer = new MutationObserver(sync);
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.timer = setTimeout(() => this.observer.disconnect(), 20000);
      sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }
  });
}
